export default "__VITE_ASSET__CJfNywS3__"